"use client";

import type React from "react";
import { ConfigProvider } from "antd";
import antdTheme from "antd/es/theme";
import { useTheme } from "./useTheme";

export const AntdThemeWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { theme: appTheme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm:
          appTheme === "dark"
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
        token: {
          /** Custom `Modal` overlay uses 120000; keep Select/Dropdown/DatePicker above it. */
          zIndexPopupBase: 130000,
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
